<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="about" class="row-content row-content_text">
      <span
        class="row-content--main"
        v-html="about"
        v-line-clamp="4"
      />
    </li>

    <partial-organisations v-if="!isEmpty(organisations)"
      :organisations="organisations"
      :highlights="highlightOrganisations"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-organisations>

    <partial-research-groups v-if="!isEmpty(researchGroups)"
      :researchGroups="researchGroups"
      :highlights="highlightResearchGroups"
      :renderWithLinkTo="false"
      :truncate="-1"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-research-groups>

    <partial-publication-count v-if="data.publications_count"
      :countPublications="data.publications_count"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-publication-count>

    <partial-project-count v-if="data.projects_count"
      :countProjects="data.projects_count"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-project-count>

    <li v-if="data.ranking_h_index" class="mt-2 row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500"><i>h</i>-index:</span>
        <span v-html="data.ranking_h_index"></span>
      </span>
    </li>
    <li v-if="data.ranking_h_index" class="mt-2 row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500">i10-index:</span>
        <span v-html="data.ranking_i10_index || 0"></span>
      </span>
    </li>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/researcher'

import Matches from '@/components/search/results/partials/Matches'
import PartialResearchGroups from '@/components/search/results/partials/ResearchGroups'
import PartialOrganisations from '@/components/search/results/partials/Organisations'
import PartialPublicationCount from '@/components/search/results/partials/PublicationCount'
import PartialProjectCount from '@/components/search/results/partials/ProjectCount'

export default {
  name: 'researcherResultPopover',
  mixins: [processing],
  components: {
    Matches,
    PartialResearchGroups,
    PartialOrganisations,
    PartialPublicationCount,
    PartialProjectCount
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      this.about ||
      !this.isEmpty(this.organisations) || !this.isEmpty(this.researchGroups) ||
      this.data.publications_count ||
      this.data.projects_count ||
      this.data.ranking_h_index
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
